import { useContext } from 'react'
import I18nContext from 'src/contexts/translations/i18nContext'

const useTranslations = () => {
  const context = useContext(I18nContext)
  if (!context) {
    throw new Error('useTranslation must be used within I18nProvider')
  }
  return context
}

export default useTranslations
